var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClose.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "sort-dialog" }, [
        _c("div", { staticClass: "sort-header" }, [
          _c("span", { staticClass: "sort-header-title" }, [
            _vm._v(
              _vm._s(_vm.$t("homePage.novelList.toolbar.sortDialogTitle"))
            ),
          ]),
          _c(
            "button",
            { staticClass: "sort-close-button", on: { click: _vm.onClose } },
            [_c("span", [_vm._v("×")])]
          ),
        ]),
        _c("div", { staticClass: "sort-body" }, [
          _c("div", { staticClass: "sort-section" }, [
            _c("h4", { staticClass: "sort-section-title" }, [
              _vm._v(_vm._s(_vm.$t("homePage.novelList.toolbar.sortCriteria"))),
            ]),
            _c(
              "div",
              { staticClass: "sort-option-list" },
              _vm._l(_vm.sortKeyOptions, function (option) {
                return _c(
                  "button",
                  {
                    key: option.value,
                    staticClass: "sort-option-item",
                    on: {
                      click: function ($event) {
                        _vm.selectedSortKey = option.value
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "sort-check",
                        class: { active: _vm.selectedSortKey === option.value },
                      },
                      [_vm._v("✓")]
                    ),
                    _c("span", { staticClass: "sort-option-label" }, [
                      _vm._v(_vm._s(option.label)),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "sort-section",
              style: {
                visibility: _vm.selectedSortKey !== "" ? "visible" : "hidden",
              },
            },
            [
              _c("h4", { staticClass: "sort-section-title" }, [
                _vm._v(
                  _vm._s(_vm.$t("homePage.novelList.toolbar.sortDirection"))
                ),
              ]),
              _c("div", { staticClass: "sort-option-list" }, [
                _c(
                  "button",
                  {
                    staticClass: "sort-option-item",
                    on: {
                      click: function ($event) {
                        _vm.selectedSortOrder = "asc"
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "sort-radio",
                      class: { active: _vm.selectedSortOrder === "asc" },
                    }),
                    _c("span", { staticClass: "sort-option-label" }, [
                      _vm._v(_vm._s(_vm.ascLabel)),
                    ]),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "sort-option-item",
                    on: {
                      click: function ($event) {
                        _vm.selectedSortOrder = "desc"
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "sort-radio",
                      class: { active: _vm.selectedSortOrder === "desc" },
                    }),
                    _c("span", { staticClass: "sort-option-label" }, [
                      _vm._v(_vm._s(_vm.descLabel)),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "sort-actions" }, [
          _c(
            "button",
            { staticClass: "sort-close-action", on: { click: _vm.onClose } },
            [_vm._v(" " + _vm._s(_vm.$t("common.close")) + " ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }